import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

 const firebaseConfig = {
   apiKey: "AIzaSyDajAmxhw-LgzDKfZqAJIdlKXdJbTyGxQs",
   authDomain: "suenosdorados-5bc21.firebaseapp.com",
   projectId: "suenosdorados-5bc21",
   storageBucket: "suenosdorados-5bc21.appspot.com",
   messagingSenderId: "39909296924",
   appId: "1:39909296924:web:74d97f6549581956fe48d9",
   measurementId: "G-0C9D8PY47G",
 };

//PRUEBAS
// const firebaseConfig = {
//   apiKey: "AIzaSyAhPnGM1ZPWRp_dg5gNqMvorozv5JfI5ww",
//   authDomain: "suenos-pruebas.firebaseapp.com",
//   projectId: "suenos-pruebas",
//   storageBucket: "suenos-pruebas.firebasestorage.app",
//   messagingSenderId: "605869850434",
//   appId: "1:605869850434:web:705ff7629baea51bde12db"
// };

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
